import { ArchiveBoxIcon, TrashIcon } from "@heroicons/react/20/solid";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useModalStore } from "@/stores/use-modal-store";
import { Study } from "@/api/studio/studies/types/study.type";
import { RenameStudyModal } from "../modals/rename-study-modal";
import { ArchiveStudyModal } from "../modals/archive-study-modal";
import { DeleteStudyModal } from "../modals/delete-study-modal";
import { CustomDropdown, CustomDropdownItem } from "@/components/ui/dropdown";
import { useArchiveStudy } from "@/api/studio/studies/queries";

/* Prop Types */
interface StudyDropdownProps {
  projectId: string;
  study: Study;
}

/*
 * StudyDropdown component
 * Simple component to keep the dropdown items for a studies in one place
 */
export const StudyDropdown = ({ projectId, study }: StudyDropdownProps) => {
  /* Stores */
  const { open } = useModalStore((state) => state.modalActions);

  /* Queries */
  const { mutateAsync: unArchiveStudy } = useArchiveStudy();

  /* Handlers */
  const handleRenameStudy = (study: Study) => {
    open(<RenameStudyModal projectId={projectId} study={study} />);
  };

  const handleArchiveStudy = (study: Study) => {
    if (study.isArchived) {
      unArchiveStudy({ projectId, studyId: study.id, values: { ...study, isArchived: false } });
      return;
    }
    open(<ArchiveStudyModal projectId={projectId} study={study} />);
  };

  const handleDeleteStudy = (study: Study) => {
    open(<DeleteStudyModal projectId={projectId} study={study} />);
  };

  /* Render */
  return (
    <CustomDropdown align="end">
      <CustomDropdownItem onClick={() => handleRenameStudy(study)}>
        <PencilSquareIcon className="size-4" /> Rename
      </CustomDropdownItem>
      <CustomDropdownItem onClick={() => handleArchiveStudy(study)}>
        <ArchiveBoxIcon className="size-4" /> {study.isArchived ? "Unarchive" : "Archive"}
      </CustomDropdownItem>
      <CustomDropdownItem className="text-error" onClick={() => handleDeleteStudy(study)}>
        <TrashIcon className="size-4" /> Delete
      </CustomDropdownItem>
    </CustomDropdown>
  );
};
